/* eslint-disable @typescript-eslint/quotes */
import { routerReducer } from '@ngrx/router-store';
import { authReducer } from './auth/reducer.auth';
import { baseReducer } from './base/reducer.base';

export const reducers = {
  [authReducer.name]: authReducer.reducer,
  [baseReducer.name]: baseReducer.reducer,
  router: routerReducer,
};
